// @ts-nocheck
import getHasHeader from "@store/Framework/Common/Utilities/getHasHeader";
import { useEffect, useState } from "react";

/**
 * Returns whether the site header is rendered on the current page.
 */
const useHasHeader = () => {
    const [hasHeader, setHasHeader] = useState(true);

    useEffect(() => {
        setHasHeader(getHasHeader());
    }, []);

    return hasHeader;
};

export default useHasHeader;
